module.exports = __webpack_public_path__ + "img/0Q3B0162_L_WoodMatted_MockedUp.4b6bc5c4.jpg";